<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Stock Por Articulo</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <button v-if="campaign" class="btn btn-neutral btn-sm btn-wd" title="Descargar" @click="downloadPdf">
            <i class="fas fa-download"></i>&nbsp;Descargar PDF
          </button>
          <button v-if="campaign" class="btn base-button btn-neutral btn-sm" @click="campaign = null">
            Cambiar Campaña
          </button>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div v-if="!campaign" class="row justify-content-center">
        <div class="col-md-6 col-sm-8 col-xs-12 card-wrapper">
          <div class="card mb-4">
            <div class="card-header">
              <h3 class="mb-0">Elija la campaña para listar los remitos</h3>
            </div>
            <div class="card-body">
              <campaign-select v-model="campaign" />
            </div>
          </div>
        </div>
      </div>

      <stock-by-article
        v-else
        :campaign-id="campaign"
        @varietyChange="getVarietyFilter"
        @sellerChange="getSellerFilter"
      />
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import CurrentCampaignMixin from '@/mixins/currentCampaignMixin';
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import StockByArticle from './List/StockByArticle.vue';

export default {
  name: 'ListByArticle',
  components: {
    RouteBreadCrumb,
    StockByArticle,
    CampaignSelect,
  },

  mixins: [CurrentCampaignMixin],

  data() {
    return {
      varietyId: 0,
      sellerId: 0,
    };
  },

  methods: {
    downloadPdf() {
      this.$services.resource('stocks').reportByArticle(this.campaign, {
        variety_id: this.varietyId,
        seller_id: this.sellerId,
        filename: 'stock-por-articulo',
      });
    },

    getVarietyFilter(varietyId) {
      this.varietyId = varietyId;
    },

    getSellerFilter(sellerId) {
      this.sellerId = sellerId;
    },
  },
};
</script>
